import { Subscription } from 'rxjs';
import { DownloadFilesService } from './../../../shared/download-files.service';
import { IngredientesCondimentosService } from './ingredientes-condimentos.service';
import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-list-ingredientes-condimentos',
  templateUrl: './list-ingredientes-condimentos.component.html',
  styleUrls: ['./list-ingredientes-condimentos.component.scss'],
})
export class ListIngredientesCondimentosComponent implements OnInit, OnDestroy {
  public subscriptions: Subscription[] = [];
  public items: any = [];
  public isLoading = true;
  public currentPage = 1;
  public pageSize = 15;
  public itemsLength = 0;
  public filter = '';

  constructor(
    private ingredientesCondimentosService: IngredientesCondimentosService,
    private downloadFilesService: DownloadFilesService
  ) {}

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  ngOnInit(): void {
    this.subscriptions = [];
    window.scroll(0, 0);
    this.getLength();
  }

  public downloadCSV(): void {
    this.subscriptions.push(
      this.ingredientesCondimentosService
        .getIngredientesCondimentos(1, 100000000000000, this.filter)
        .subscribe(
          (response) => {
            const date = new Date();
            console.log('Date ingredientes: ', date);
            console.log('Date ingredientes month : ', date.getUTCMonth());
            const months = [
              'Enero',
              'Febrero',
              'Marzo',
              'Abril',
              'Mayo',
              'Junio',
              'Julio',
              'Agosto',
              'Septiembre',
              'Octubre',
              'Noviembre',
              'Diciembre',
            ];
            const filename =
              'Listado ingredientes y condimentos (' +
              ('' + date.getUTCDate()).padStart(2, '0') +
              '-' +
              months[date.getUTCMonth()] +
              '-' +
              date.getUTCFullYear() +
              ')';
            console.log('Filename: ', filename);
            let tmp = '';
            let div;
            for (let i = 0; i < response.length; i++) {
              // delete response[i]['PLATOS ASIGNADOS'];
              tmp = response[i].platos_asignados
                ? response[i].platos_asignados
                : '';
              div = document.createElement('a');
              div.innerHTML = tmp.trim();
              tmp = div.textContent ? div.textContent.toString() : '';

              response[i].platos_asignados = tmp;

              response[i].n_platos_asignados =
                (response[i].platos_asignados.match(/,/g) || []).length + 1;
            }

            console.log('Aux: ', response);
            this.downloadFilesService.downloadCSV(response, filename);
          },
          (err) => {
            console.log(err);
            this.isLoading = false;
          }
        )
    );
  }

  public onPageChange(page: number): void {
    console.log('Changing page to: ', page);
    this.getIngredientesCondimentos(page, this.pageSize);
  }

  public getLength(): void {
    this.currentPage = 1;
    this.subscriptions.push(
      this.ingredientesCondimentosService
        .getIngredientesCondimentosLength(this.filter)
        .subscribe(
          (response) => {
            console.log('Length response: ', response);
            this.itemsLength = response[0].length;
            console.log('itemsLength: ', this.itemsLength);
            this.getIngredientesCondimentos(this.currentPage, this.pageSize);
          },
          (err) => {
            console.log(err);
            this.isLoading = false;
          }
        )
    );
  }

  public resetFilters(): void {
    this.filter = '';
    this.currentPage = 1;
    this.getLength();
  }

  private getIngredientesCondimentos(page: number, pageSize: number): void {
    this.subscriptions.push(
      this.ingredientesCondimentosService
        .getIngredientesCondimentos(page, pageSize, this.filter)
        .subscribe(
          (response) => {
            for (let i = 0; i < response.length; i++) {
              response[i].n_platos_asignados =
                (response[i].platos_asignados.match(/,/g) || []).length + 1;
            }
            this.items = response;
            console.log('this.items: ', this.items);
            this.isLoading = false;
          },
          (err) => {
            console.log(err);
            this.isLoading = false;
          }
        )
    );
  }
}
